import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=6aeb120f&scoped=true&lang=pug&"
import script from "./Block.vue?vue&type=script&lang=js&"
export * from "./Block.vue?vue&type=script&lang=js&"
import style0 from "./Block.scss?vue&type=style&index=0&id=6aeb120f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb120f",
  null
  
)

export default component.exports